// filepath: /Users/a1111/WebstormProjects/arch-editor/src/components/boards/BoardC4.js
import React from 'react';
import Canvas from '../Canvas';
import ToolbarC4 from './ToolbarC4';

// C4 доска: Canvas + ToolbarC4 (по аналогии с BoardArchimate)
const BoardC4 = ({ diagramId = null, projectId = null }) => {
  return <Canvas initialDiagramId={diagramId} mode="c4" projectId={projectId} ToolbarComponent={ToolbarC4} />;
};

export default BoardC4;
